import React from "react";
import {
  FooterContainer,
  MapContainer,
  ContactContainer,
  InfoContainer,
  Paragraph,
  Logo,
  StyledLink,
} from "./footer-styles";
import { Map } from "..";
import { Subtitle } from "../info-box/info-box-styles";

export const Footer = () => {
  return (
    <FooterContainer>
      <MapContainer>
        <Map />
      </MapContainer>
      <ContactContainer>
        <InfoContainer>
          <Subtitle
            $hover
            href="https://www.google.com/maps?ll=55.836186,-4.235417&z=16&t=m&hl=en-GB&gl=US&mapclient=embed&q=37+Rosyth+Rd+Glasgow+G5+0YD"
            target="_blank"
            rel="noreferrer"
          >
            Location
          </Subtitle>
          <Paragraph>
            Unit 33,
            <br />
            37 Rosyth Road,
            <br />
            G5 0YD,
            <br />
            Glasgow
          </Paragraph>
          <StyledLink to="/contact">Contact Form</StyledLink>
        </InfoContainer>
        <Logo src="assets/logo.svg" alt="logo" />
      </ContactContainer>
    </FooterContainer>
  );
};
